import React from 'react';
import { Link } from 'react-router-dom';
import AdminPanelSettingsOutlined from '@mui/icons-material/AdminPanelSettingsOutlined';
import { isAdminEmail } from '../../utils/isAdmin';
import { ADMIN } from '../../constants/routes';

const AdminMenuLink = ({
  email,
  t,
  onClick,
  className = 'dropdown-item fw-semi-bold',
  style,
  showDividerAfter = false,
}) => {
  if (!isAdminEmail(email)) {
    return null;
  }

  return (
    <>
      <Link
        className={className}
        to={ADMIN}
        onClick={onClick}
        style={{ color: 'inherit', ...style }}
      >
        <AdminPanelSettingsOutlined style={{ display: 'inline-grid', paddingRight: '2px' }} />
        <span style={{ marginLeft: className.includes('nav-link') ? '5px' : undefined }}>
          {t ? t('header.nav.admin') : 'Admin'}
        </span>
      </Link>
      {showDividerAfter ? <div className="new-dropdown-divider order-5" /> : null}
    </>
  );
};

export default AdminMenuLink;
